// @flow
import { avoInspector } from '@toggl/avo'
import { filterData } from '@toggl/avo/src/utils'

// A wrapper over Avo, Heap, Google Analytics to track events in one place.
export const inspectAndTrack = (
  eventName: string,
  data: { [key: string]: any } | null = {},
  options: {
    avo?: boolean,
    heap?: boolean,
    ga?: boolean,
    callback?: () => void,
  } = {
    avo: true,
    heap: true,
    ga: true,
  }
): void => {
  if (typeof window === 'undefined') return
  const trackAvo = options.avo ?? true
  const trackHeap = options.heap ?? true
  const trackGa = options.ga ?? true
  const filteredData = filterData(data)
  const filteredDataGa = options.callback
    ? { ...filteredData, event_callback: options.callback }
    : filteredData
  trackAvo && avoInspector?.trackSchemaFromEvent(eventName, filteredData ?? {})
  trackHeap && window?.heap && window.heap.track(eventName, filteredData)
  trackGa &&
    window?.gtag &&
    window.gtag('event', eventName, filteredDataGa ?? {})
}
